// extracted by mini-css-extract-plugin
export default {"h1":"ActivityDateHeader__h1___E8hET","year":"ActivityDateHeader__year___Plndy"};